module.exports = __webpack_public_path__ + "static/media/r.0d4aac3b.jpg";